import { render, staticRenderFns } from "./CheckoutVendorProfile.vue?vue&type=template&id=47855a2d"
import script from "./CheckoutVendorProfile.vue?vue&type=script&lang=ts"
export * from "./CheckoutVendorProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports